module.exports = __webpack_public_path__ + "static/media/ic_checkout-car.797627a2.svg";